import { Formik } from "formik";
import React, { useState } from "react";
import BetterButton from "../../components/BetterButton";
import BetterTextField from "../../components/BetterTextField";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Eye, EyeClosed } from 'lucide-react';

export default function Login(props) {
	const [showSenha, setShowSenha] = useState(false);

	const validate = (values) => {
		const errors = {};

		if (!values.email) {
			errors.email = "O campo email é obrigatório.";
		} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
			errors.email = "Você precisa informar um email válido.";
		}

		if (!values.password) {
			errors.password = "O campo senha é obrigatório.";
		}

		return errors;
	}

	const submit = (values) => {
		props.handle(values)
	}

	return (
		<div className="auth-login">
			<Formik
				initialValues={{ email: "", password: "" }}
				validate={validate}
				onSubmit={submit}>
				{({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
					<form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
						{status ? (
							<div role="alert" className="alert alert-danger">
								<div className="alert-text">{status}</div>
							</div>
						) : null}
						<div className="login-interno">
							<p className="titulo" style={{ textAlign: 'center', marginBottom: 24 }}>Acesse sua conta</p>

							<div className="row">
								<div className="col-sm-12">
									<BetterTextField required type="email" label="E-mail" name="email" onBlur={handleBlur} onChange={handleChange} value={values.email} helperText={touched.email && errors.email} error={Boolean(touched.email && errors.email)} />
								</div>
							</div>
							
							<div className="row">
								<div className="col-sm-12">
									<BetterTextField required type={showSenha ? 'text' : "password"} name="password" label='Senha' onBlur={handleBlur} onChange={handleChange} value={values.password} helperText={touched.password && errors.password} error={Boolean(touched.password && errors.password)} InputProps={{
										endAdornment:
											<InputAdornment position="end">
												<IconButton
													onClick={() => setShowSenha(!showSenha)}
													edge="end"
												>
													{showSenha ? <Eye /> : <EyeClosed />}
												</IconButton>
											</InputAdornment>
									}} />
								</div>
							</div>


							<p className="senha"><span onClick={() => props.setPage('SENHA')}>Esqueci minha senha</span></p>

							<BetterButton loading={props.loading} className="btn btn-primary" style={{ width: '100%' }}>Entrar</BetterButton>
						</div>
					</form>
				)}
			</Formik>
		</div>
	);
}


